<template>
  <div class="carrossel-produtos">
    <div class="swiper-container" :class="`carrossel${id}`">
      <div class="swiper-wrapper" role="list">
        <div class="swiper-slide p-1" role="listitem" v-for="(s, index) in itens" :key="index" :class="{small}">
          <a href="javascript:" @click="goTo(s)" class="card card-produto mb-0" :class="{'card-border': small}">
            <imagem-carregavel class="produto-foto" lazy :fallback="base_cdn + '/static/imgs/default.png'" :src="s.url_imagem || (base_cdn + '/static/imgs/default.png')" aria-hidden="true" :alt="s.nome_produto" />
            <div class="text-dark">
              <div class="m-0 limite-1">{{s.nome_produto}}</div>
              <h6 class="card-produto-preco font-weight-bold text-dark mb-0" v-if="s.valor > 0">
                <span class="small mr-1" v-if="s.qtd_tabelas > 1 && s.valor > 0">A partir de</span>
                <b :class="s.valor_base > s.valor && s.qtd_tabelas === '1' ? 'text-success' : 'text-dark'">{{s.valor | valor}}</b>
                <s class="text-dark pl-1 small" v-if="s.valor_base > s.valor && s.qtd_tabelas === '1' && !small">{{s.valor_base | valor}}</s>
              </h6>
              <h6 class="card-produto-preco font-weight-bold text-dark mb-0" v-else>Ver opções</h6>
              <div class="card-produto-tag-space" v-if="hasTags">
                <produto-tag :id-tag="s.id_tag"/>
              </div>
            </div>
            <div class="px-2 mt-1" v-if="!small">
              <button class="btn btn-primary btn-sm btn-block font-weight-bold">Adicionar</button>
            </div>
          </a>
        </div>
      </div>
    </div>

    <button
      v-show="temOverflow && !noInicio"
      type="button"
      class="carrossel-produtos-seta carrossel-produtos-anterior"
      aria-label="Ver produtos anteriores"
      @click="navegar(-1)"
    >
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </button>
    <button
      v-show="temOverflow && !noFim"
      type="button"
      class="carrossel-produtos-seta carrossel-produtos-proxima"
      aria-label="Ver mais produtos"
      @click="navegar(1)"
    >
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
    import ImagemCarregavel from './ImagemCarregavel'
    import Swiper from 'swiper'
    import 'swiper/dist/css/swiper.css'
    import ProdutoTag, { getProdutoTag } from './ProdutoTag'

    export default {
      name: "carrosell",
      components: { ImagemCarregavel, ProdutoTag },
      props: ['slides', 'small'],
      data() {
        return {
          id: this.$helpers.ID(),
          itens: [],
          url: '',
          temOverflow: false,
          noInicio: true,
          noFim: false
        }
      },

      computed: {
        hasTags() {
          return this.itens.some(item => !!getProdutoTag(item.id_tag));
        }
      },

      methods: {
        atualizarNavegacao() {
          if (!this.swiper) return;

          this.temOverflow = !this.swiper.isBeginning || !this.swiper.isEnd;
          this.noInicio = this.swiper.isBeginning;
          this.noFim = this.swiper.isEnd;
        },

        atualizarInteracao() {
          if (!this.swiper) return;

          this.swiper.allowTouchMove = window.innerWidth < 768;
        },

        navegar(direcao) {
          if (!this.swiper) return;

          const larguraSlide = this.swiper.slides[0] ? this.swiper.slides[0].offsetWidth : 200;
          const quantidadeVisivel = Math.max(1, Math.floor(this.swiper.width / larguraSlide));
          const destino = this.swiper.activeIndex + (direcao * quantidadeVisivel);
          this.swiper.slideTo(Math.max(0, Math.min(destino, this.itens.length - 1)));
        },

        goTo(s) {
          if (this.small) {
            this.$emit('selProduto', s);

          } else {
            this.$router.push(`${this.url}/categorias/?id=${s.id_categoria}&produto=${s.id_produto}`);
          }
        }
      },

      mounted() {
        this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
        this.itens = this.slides.slice(0, 8);
        this.$nextTick(() => {
          this.swiper = new Swiper(`.carrossel${this.id}`, {
            slidesPerView: 'auto',
            freeMode: true,
            allowTouchMove: window.innerWidth < 768,
            watchOverflow: true,
            on: {
              init: this.atualizarNavegacao,
              progress: this.atualizarNavegacao,
              resize: () => {
                this.atualizarNavegacao();
                this.atualizarInteracao();
              }
            }
          });
          this.atualizarNavegacao();
          this.atualizarInteracao();
        })
      },

      beforeDestroy() {
        if (this.swiper) this.swiper.destroy();
      }
    }
</script>

<style>
  .carrossel-produtos .btn.btn-block {
    min-height: 0;
    padding: 6px 0;
  }

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .card-produto .produto-foto {
    display: block;
    border-radius: 18px;
    width: 100%;
    height: 115px;
    object-fit: cover;
    margin-bottom: 8px;
  }

  .card-produto .produto-foto ::v-deep img {
    height: 100%;
    margin-bottom: 0;
    border-radius: 0;
    background: transparent;
  }

  .carrossel-produtos {
    position: relative;
  }

  .carrossel-produtos-seta {
    display: none;
  }

  .swiper-slide {
    width: 200px;
  }

  .swiper-slide.small {
    width: 130px;
  }

  .swiper-slide.small .card-produto .produto-foto {
    height: 90px;
  }

  .swiper-slide.small .card-produto {
    border: 1px solid #e3e6e9;
    box-shadow: none;
  }

  .card-produto-preco {
    display: flex;
    min-height: 27px;
    align-items: center;
    justify-content: center;
  }

  .card-produto-tag-space {
    display: flex;
    height: 27px;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .card-produto-tag-space .produto-tag {
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    .carrossel-produtos-seta {
      position: absolute;
      top: 50%;
      display: flex;
      width: 36px;
      height: 36px;
      padding: 0;
      align-items: center;
      justify-content: center;
      border: 0;
      border-radius: 50%;
      background: #fff;
      color: #111;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .25);
      opacity: 0;
      pointer-events: none;
      transition: opacity .2s ease;
      transform: translateY(-50%);
      z-index: 2;
      cursor: pointer;
    }

    .carrossel-produtos:hover .carrossel-produtos-seta,
    .carrossel-produtos-seta:focus-visible {
      opacity: 1;
      pointer-events: auto;
    }

    .carrossel-produtos-anterior {
      left: 10px;
    }

    .carrossel-produtos-proxima {
      right: 10px;
    }
  }

  @media (hover: none), (pointer: coarse) {
    .carrossel-produtos-seta {
      display: none;
    }
  }

</style>
